import { configureStore } from '@reduxjs/toolkit';
import { faceCaptureSlice } from '@features/face-capture';

export const store = configureStore({
  reducer: {
    [faceCaptureSlice.name]: faceCaptureSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
